module.exports = __webpack_public_path__ + "img/editCalculationTypeDialog.d2aaba75.jpg";